'use client';

import React from 'react';
import ImgMask from './ImgMask';
import { LoginModal } from './LoginModal';
import { LogoutModal } from './LogoutModal';
import { ContactModal } from './ContactModal';
import { UserBannedAppealModal } from './UserBannedAppealModal';
import { useInitPage } from '@whelk/hooks/src/useInitPage';
import { GetWebCommonConfigMeta } from '@whelk/services/src/type/chat';
import NotificationLiveModal from './NotificationLiveModal';

const GlobalModals = ({ commonConfig }: { commonConfig: GetWebCommonConfigMeta }) => {
  useInitPage(commonConfig);

  return (
    <>
      <ImgMask />
      <LoginModal />
      <LogoutModal />
      <ContactModal />
      <UserBannedAppealModal />
      <NotificationLiveModal />
    </>
  );
};

export { GlobalModals };
